import {OEAsset, useClient, useDictionary, useItem, useItems, useOnScreen} from '@adamlip/okeoke.client'
import {Card, CardBody} from '@heroui/react'
import Icon from 'assets/icons'
import FormattedNumber from 'components/FormattedNumber'
import OrderItemModalV3 from 'components/Modals/OrderItemModalV3'
import {AppParamsContext} from 'contexts/AppParamsContext'
import {UserContext} from 'contexts/UserContext'
import useBasket from 'hooks/useBasket'
import {useContext, useEffect, useRef, useState} from 'react'
import toast from 'react-hot-toast'
import {LeadingActions, SwipeableList, SwipeableListItem, SwipeAction} from 'react-swipeable-list'
import 'react-swipeable-list/dist/styles.css'
import SendVibration from 'utils/Helpers-v1/SendVibration'

function ItemData({menuItemParams, itemUUID, selectedSizeUUID, forceHideDesc, banned, readOnly}) {
	const {userLoggedIn} = useContext(UserContext)
	const {appParams} = useContext(AppParamsContext)
	const [itemModalOpen, setItemModalOpen] = useState(false)
	const defaultCountDone = useRef(null)
	const rootMargin = '0px'
	const ref = useRef(null)
	const onScreen = useOnScreen(ref, rootMargin)
	const {assembledItem, setCount} = useItem(itemUUID, selectedSizeUUID)
	const {addItem} = useBasket()
	const {getValue} = useDictionary()
	const {assembledItems} = useItems()
	const {getName} = useClient()

	const addItemToBasket = (count) => {
		setCount(count)
		if (userLoggedIn) {
			if (menuItemParams && typeof menuItemParams?.onAdd === 'function') {
				if (assembledItem.count > 0 && assembledItem.valid) {
					menuItemParams?.onAdd(assembledItem)
				} else {
					setItemModalOpen(true)
				}
			} else {
				if (assembledItem.count > 0 && assembledItem.valid) {
					let response = addItem(assembledItem)
					if (response != null) {
						toast.success(getValue('app_v2_toast_itemAdded'))
						SendVibration('success')
					} else {
						SendVibration('error')
						console.log(response)
						toast.error(getValue('app_v2_toast_itemFailed'))
					}
				} else {
					toast.error(getValue('app_v2_toast_itemFailed'))
				}
			}
		} else {
			toast.error(getValue('app_v2_toast_needLogin'))
		}
	}
	useEffect(() => {
		const isOnScreen = menuItemParams?.onScreenOff === true ? true : onScreen
		if (assembledItem != null && !defaultCountDone.current && menuItemParams?.defaultCount > 0 && isOnScreen && !readOnly) {
			addItemToBasket(menuItemParams?.defaultCount)
			defaultCountDone.current = true
		}
	}, [assembledItem, menuItemParams, readOnly, onScreen])
	const leadingActions = () => (
		<LeadingActions>
			<SwipeAction
				onClick={() => {
					if (assembledItem?.valid && (assembledItem?.modifierGroups || [])?.filter((modGroup) => modGroup?.availability?.visible === 1 && modGroup?.availability?.available === 1)?.length === 0 && assembledItem?.sizes?.length === 1 && !banned) {
						addItemToBasket(1)
						return
					} else {
						if (!banned) {
							setItemModalOpen(true)
							SendVibration('light')
						}
					}
				}}>
				<div className='h-full right-[-10px] bg-primary  flex items-center justify-center p-2 text-primary-foreground'>{banned ? getValue('app_v2_min18') : getValue('app_v2_addToBasket')}</div>
			</SwipeAction>
		</LeadingActions>
	)

	return (
		<>
			<OrderItemModalV3 isOpen={itemModalOpen} setIsOpen={setItemModalOpen} itemUUID={assembledItem?.uuid} readOnly={readOnly} menuItemParams={menuItemParams} sizeUUID={menuItemParams?.selectedSizeUUID} />

			<SwipeableList fullSwipe className='w-full'>
				<SwipeableListItem leadingActions={leadingActions()} className='w-full'>
					<Card
						shadow='none'
						className={`${appParams?.items?.imageFirst ? '' : 'pl-2'} rounded-itemCard overflow-hidden border-1 min-h-[110px] border-orderItemBorder bg-orderItemCardBackground shrink-0 max-h-[110px] h-[110px]  text-orderItemCardText w-full flex flex-row gap-2`}
						onPress={() => {
							setItemModalOpen(true)
							SendVibration('light')
						}}
						isPressable>
						{!readOnly && banned && <div className='absolute w-full h-full top-0 left-0 bg-black/70 text-white z-[50] flex items-center justify-center font-bold'>{getValue('app_v2_min18')}</div>}

						<CardBody className='p-0 flex flex-row gap-2 overflow-hidden h-full w-full'>
							<div className={`grow flex flex-col gap-0 overflow-x-hidden overflow-y-hidden `}>
								<div className={`${appParams?.items?.truncateName ? 'w-full truncate' : ''} font-bold text-itemName text-orderItemCardText`}>{getName(assembledItem?.name)}</div>
								<div className='grow overflow-hidden w-full'>{!forceHideDesc && !appParams?.items?.hideDescription && <div className='line-clamp-3   opacity-70 font-light text-itemDesc'>{getName(assembledItem?.description)}</div>}</div>
								<div className='text-orderItemPrice text-itemPrice font-medium'>
									{menuItemParams?.price != null ? <FormattedNumber value={+menuItemParams?.price + +assembledItems?.[assembledItem?.uuid]?.depositPrice} /> : <FormattedNumber value={assembledItems?.[assembledItem?.uuid]?.totalPriceUnit || 0} />}
								</div>
								<div className='flex justify-end h-[20px] absolute bottom-2 right-2 gap-1 opacity-70'>
									{assembledItem?.tags
										?.filter((tag) => ['dairyFree', 'vegan', 'glutenFree', 'vegetarian'].includes(tag))
										.map((tag, index) => (
											<Icon key={index} name={tag} className={'fill-white stroke-white'} secondClassName={'fill-primary/80'} />
										))}
								</div>
							</div>
							{appParams?.items?.showImage !== false && appParams?.assets?.defaultItemImg != null && (
								<OEAsset
									addContainerClass={`${appParams?.items?.imageFirst ? 'order-first' : ''} flex aspect-itemCardImage rounded-itemCardImage overflow-hidden items-center justify-center shrink-0 h-full max-w-[165px]`}
									addClass={`w-full h-full ${appParams?.items?.imageFit === 'cover' ? 'object-cover' : 'object-contain'}`}
									size='l'
									defaultItemImg={appParams?.assets?.defaultItemImg}
									uuid={assembledItem?.attributes?.appImage}
								/>
							)}
						</CardBody>
					</Card>
				</SwipeableListItem>
			</SwipeableList>
		</>
	)
}

export default ItemData
